export default [
    {
        route: 'tasks.tasks.index',
        label: 'messages.sitemap.tasks.open-tasks',
        showInSidebar: true,
        id: 'tasks-index'
    },
    {
        route: 'tasks.tasks.done',
        label: 'messages.sitemap.tasks.done-tasks',
        activeSidebarRoute: 'tasks.tasks.index',
        id: 'tasks-done-index'
    }
]
